import { createContext, useContext } from 'react'
import type {
  OnboardingStateResponse,
  UpdateOnboardingDto,
} from '@super/shared-types'

export interface OnboardingContextValue {
  state: OnboardingStateResponse
  patch: (input: UpdateOnboardingDto) => Promise<OnboardingStateResponse>
  refetch: () => Promise<void>
}

export const OnboardingContext = createContext<OnboardingContextValue | null>(
  null,
)

export function useOnboarding(): OnboardingContextValue {
  const ctx = useContext(OnboardingContext)
  if (!ctx) {
    throw new Error('useOnboarding must be used within OnboardingLayout')
  }
  return ctx
}
